import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { debounceIfPossible } from "@faire/web--source/common/globals/debounceIfPossible";
import { useMutation as useBusinessAddress } from "@faire/web-api--source/api/retailer/find-business-address/post-hooks";
import { QueryParameters } from "@faire/web-api--source/api/retailer/find-businesses/get";
import { useQuery as useFindBusinessesQuery } from "@faire/web-api--source/api/retailer/find-businesses/get-hooks";
import { useEffect, useState } from "react";
export var useAutoComplete = function(query, country) {
    var _useState = _sliced_to_array(useState(false), 2), isDropdownOpen = _useState[0], setIsDropdownOpen = _useState[1];
    var _useState1 = _sliced_to_array(useState(false), 2), queryBusinesses = _useState1[0], setQueryBusinesses = _useState1[1];
    var _useState2 = _sliced_to_array(useState([]), 2), autoCompleteResults = _useState2[0], setAutoCompleteResults = _useState2[1];
    var _useFindBusinessesQuery = useFindBusinessesQuery(QueryParameters.build({
        query: query,
        country: country
    }), {
        enabled: queryBusinesses
    }), businesses = _useFindBusinessesQuery.data, isLoading = _useFindBusinessesQuery.isPending, isFetching = _useFindBusinessesQuery.isFetching;
    var _useBusinessAddress = useBusinessAddress(), getBusinessAddress = _useBusinessAddress.mutate;
    var debouncedSearch = debounceIfPossible(function(enable) {
        return setQueryBusinesses(enable);
    }, 250);
    useEffect(function() {
        if (query.length > 2) {
            debouncedSearch(true);
        } else {
            debouncedSearch(false);
        }
    }, [
        query,
        country,
        debouncedSearch
    ]);
    useEffect(function() {
        if (businesses) {
            setAutoCompleteResults(businesses.map(function(business) {
                var _business_id;
                return _object_spread_props(_object_spread({}, business), {
                    id: (_business_id = business.id) !== null && _business_id !== void 0 ? _business_id : ""
                });
            }));
        } else {
            setAutoCompleteResults([]);
        }
    }, [
        businesses
    ]);
    return {
        isDropdownOpen: isDropdownOpen,
        setIsDropdownOpen: setIsDropdownOpen,
        autoCompleteResults: autoCompleteResults,
        getBusinessAddress: getBusinessAddress,
        areBusinessesLoading: isLoading && isFetching
    };
};
